import {Component, OnInit, ViewEncapsulation, AfterViewInit} from '@angular/core';
import {AccessHelper} from 'helpers/access.helper';
import {HttpClient} from '@angular/common/http';
import {Helpers} from 'helpers';
import {ParkingDataService} from 'core/data-services/parking/parking.service';

declare let mLayout: any;

@Component({
  selector: 'app-aside-nav',
  templateUrl: './aside-nav.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class AsideNavComponent implements OnInit, AfterViewInit {
  accessHelper = AccessHelper;
  hasBlueGate: boolean;
  hasBlueLock: boolean;
  hasLift: boolean;
  hasPayment: boolean = false;
  isShowReportsMenu: boolean = false;
  isShowPromotionMenuTab: boolean = false;
  parkingLotId;

  constructor(public http: HttpClient, private parkingDataService: ParkingDataService) {
  }

  ngOnInit() {
    this.isShowReportsMenu = this.isShowReportsMenuFn();

    this.parkingDataService.getParkingLotById().then((response: any) => {
      if (response) {
        this.parkingLotId = response.id;
        this.hasBlueLock = response.hasLocker;
        this.hasBlueGate = response.hasGate;
        this.hasLift = response.hasLift;
        this.hasPayment = (response.enableRateMonthly || response.enableRateTemporary);
        this.isShowPromotionMenuTab = this.isShowPromotionMenuTabFn();
      }
    }).catch((error) => {
    });
  }

  ngAfterViewInit() {
    mLayout.initAside();
  }

  isShowReportsMenuFn() {
    return this.accessHelper.hasMenuAccessPermission('REPORT')
      || this.accessHelper.hasMenuAccessPermission('1MOVE_REPORT_USAGE')
      || this.accessHelper.hasAccessPromotionMenu();
  }

  isShowPromotionMenuTabFn() {
    const hasReportAndPayment = (this.accessHelper.hasMenuAccessPermission('REPORT') && this.hasPayment);
    return hasReportAndPayment || this.accessHelper.hasAccessPromotionMenu();
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/layouts/aside-nav/aside-nav.component.ts